if ( typeof ShippingNotice !== 'function' ) {

  /*
   * SNA – drempel voor gratis verzending per land (in EUR).
   * Per land staat altijd de GOEDKOOPSTE drempel voor gratis verzending,
   * d.w.z. het laagste bedrag waarvoor minstens één verzendmethode gratis is
   * (meestal Servicepunt DPD; waar geen servicepunt is: thuislevering / UPS / PostNL).
   * Moet overeenkomen met Shopify > Instellingen > Verzending en levering.
   * Laatst bijgewerkt: 21/09/2026 (terugkeer naar DPD + servicepunt).
   * Landen die niet in de lijst staan (geen gratis verzending) krijgen geen balk.
   */
  const SNA_FREE_SHIPPING_THRESHOLDS = {
    BE: 30,
    NL: 40,
    DE: 50, FR: 50, LU: 50,
    AT: 70, CZ: 70, PL: 70,
    HU: 80, IT: 80, LT: 80, SI: 80, SK: 80,
    ES: 90, HR: 90,
    DK: 100, EE: 100, IE: 100, LV: 100, PT: 100, SE: 100,
    FI: 130, GR: 130,
    MC: 150,
    RO: 160,
    CH: 200, CY: 200, GB: 200, NO: 200,
    BG: 220,
    MT: 250, RS: 250,
    GG: 280, IS: 280, LI: 280, MK: 280, VA: 280,
    AX: 300, GI: 300, IM: 300, JE: 300, MD: 300, ME: 300, SM: 300,
    AD: 400
  };

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.#init();
    }

    #getThreshold() {
      const country = ( window.Shopify && window.Shopify.country ) ? String(window.Shopify.country).toUpperCase() : null;
      if ( country ) {
        return Object.prototype.hasOwnProperty.call(SNA_FREE_SHIPPING_THRESHOLDS, country) ? SNA_FREE_SHIPPING_THRESHOLDS[country] * 100 : 0;
      }
      // Land onbekend: val terug op het bedrag uit de thema-instellingen
      return Number(this.getAttribute('data-free-shipping')) || 0;
    }

    #init() {

      const freeShippingThreshold = this.#getThreshold();

      if ( !freeShippingThreshold ) {
        this.innerHTML = '';
        this.style.display = 'none';
        return;
      }

      const cartTotal = Number(this.getAttribute('data-cart-total-amount'));
      const freeShippingRemaining = cartTotal - Math.round(freeShippingThreshold * (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1));
      let shippingMessage = '';
      let shippingSuccess = false

      if ( freeShippingRemaining < 0 ) {
        shippingMessage = window.KROWN.settings.locales.shipping_notice_remaining_to_free.replace('{{ remaining_amount }}', this.#formatMoney(Math.abs(freeShippingRemaining), KROWN.settings.shop_money_format));

      } else {
        shippingMessage = window.KROWN.settings.locales.shipping_notice_eligible_for_free;
        shippingSuccess = true;
      }

      if ( this.hasAttribute('data-show-alert') ) {
        this.innerHTML = `
          <div class="alert alert--wide alert--${shippingSuccess ? 'success' : 'note'}">
            ${shippingMessage}
          </div>`;
      } else {
        this.innerHTML = shippingMessage;
      }

    }

    #formatMoney(cents, format) {

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}

			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || moneyFormat;

			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';

				if (isNaN(number) || number === null) {
					return 0;
				}

				number = (number / 100.0).toFixed(precision);

				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';

				return dollarsAmount + centsAmount;
			}

			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}

			return formatString.replace(placeholderRegex, value);

		}

  }

  if ( typeof customElements.get('shipping-notice') === 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}
